/**
 * Les fonctions qu'un interrupteur cache (décision 15 du 16/10), telles que
 * l'API les annonce : l'écran tait menus, boutons et textes de ce qui est
 * éteint.
 *
 * Tant que la réponse manque, tout est éteint : mieux vaut un bouton qui
 * apparaît une fraction de seconde trop tard qu'un bouton qui mène à un 404.
 */
import { useQuery } from '@tanstack/react-query'
import { schemaFonctions, type Fonctions } from '@afs/shared'
import { requete } from './api/client.js'
import { useSession } from '../modules/socle-auth/session.js'

export const TOUT_ETEINT: Fonctions = {
  ocrDns: false,
  pdfNatifDns: false,
  scanCoupure: false,
  formulairesCoupure: false,
  caisse: false,
  activiteMedecins: false,
  fileCaisse: false,
  dureeEcoulee: false,
  tableauDeBord: false,
  dnsMouvements: false,
  ecranProchains: false,
  numerosPassage: false,
  videosTele: false,
  prixDentiste: false,
  ayantDroitSansConfirmation: false,
  superAdminPartout: false,
}

export const clesFonctions = { toutes: () => ['fonctions'] as const }

export function lireFonctions(): Promise<Fonctions> {
  return requete('/fonctions', { schema: schemaFonctions })
}

export function useFonctions(): { fonctions: Fonctions; chargement: boolean } {
  const { utilisateur } = useSession()
  const requeteFonctions = useQuery({
    queryKey: clesFonctions.toutes(),
    queryFn: lireFonctions,
    // L'état ne change qu'au redémarrage de l'API, mais un onglet ouvert
    // garde son cache : relu toutes les 5 min, comme la session.
    staleTime: 5 * 60 * 1000,
    enabled: utilisateur !== undefined,
  })
  return {
    fonctions: requeteFonctions.data ?? TOUT_ETEINT,
    chargement: utilisateur !== undefined && requeteFonctions.isPending,
  }
}
